<app-header></app-header>
<div class="help-wrapper">

  <!-- ═══════════════════════════════════════════════
       HERO — matches faq-hero exactly
  ═══════════════════════════════════════════════ -->
  <section class="help-hero" aria-labelledby="help-hero-title">
    <div class="help-hero-bg"></div>
    <div class="help-hero-overlay"></div>

    <div class="help-hero-inner">
      <div class="help-eyebrow">
        <span class="help-pill-dot"></span>
        Help Center
      </div>

      <h1 id="help-hero-title" class="help-hero-title">
        Real answers,<br /><em>right here.</em>
      </h1>

      <p class="help-hero-sub">
        Find answers about NEXGEN Executive Coaching Academy platform access, live sessions,
        barter coaching, ICF credentialing, billing, and support.
        Or reach a real person — we respond within one business day.
      </p>

      <div class="help-hero-cta">
        <a
          href="https://academy.nexgencoaches.com/live-session"
          target="_blank"
          rel="noopener noreferrer"
          class="btn-gold-solid">
          ATTEND FREE WEBINAR
        </a>
        <a
          href="https://nexgencoaches.com/contact-us/"
          target="_blank"
          rel="noopener noreferrer"
          class="btn-white-outline">
          CONTACT SUPPORT →
        </a>
      </div>
    </div>
  </section>

  <!-- ═══════════════════════════════════════════════
       AT A GLANCE — cream-section with accordion-rows
       matches FAQ "What this page covers" section
  ═══════════════════════════════════════════════ -->
  <section class="cream-section" *ngIf="!searchTerm">
    <div class="cx">
      <p class="gold-eyebrow">HELP CENTER OVERVIEW</p>
      <h2>What this page <em>covers.</em></h2>
      <p class="section-lead">
        This page helps you quickly find answers about platform access, live sessions,
        coaching hours, ICF credentialing, billing, and support.
      </p>

      <div class="accordion-rows">
        <div class="acc-row">
          <div class="acc-num">1</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>Login &amp; Platform Access</strong>
            <p>Find help with signing in, resetting your password, and navigating the platform.</p>
          </div>
          <div class="acc-result">
            <em>Get in and get moving. Fast answers for access issues.</em>
          </div>
        </div>

        <div class="acc-row">
          <div class="acc-num">2</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>Live Sessions &amp; Coaching Hours</strong>
            <p>Learn how to join webinars, use the Barter Platform, and log your coaching sessions.</p>
          </div>
          <div class="acc-result">
            <em>Built for busy adults. Miss nothing. Fall behind on nothing.</em>
          </div>
        </div>

        <div class="acc-row">
          <div class="acc-num">3</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>ICF Credentialing</strong>
            <p>Get guidance on requirements, documentation, and exam preparation steps.</p>
          </div>
          <div class="acc-result">
            <em>Clear steps toward your credential. No guesswork.</em>
          </div>
        </div>

        <div class="acc-row">
          <div class="acc-num">4</div>
          <div class="acc-divider"></div>
          <div class="acc-body">
            <strong>Account &amp; Billing</strong>
            <p>Learn how upgrades, profile changes, and payment support work.</p>
          </div>
          <div class="acc-result">
            <em>Upgrade any time. Your progress always carries forward.</em>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ═══════════════════════════════════════════════
       QUICK ACTIONS — cream-section with ft-row style rows
       matches FAQ "Most Asked" feature-table layout
  ═══════════════════════════════════════════════ -->
  <section class="quick-actions-bar" *ngIf="!searchTerm">
    <div class="cx">
      <p class="gold-eyebrow">QUICK ACTIONS</p>
      <h2>Get help <em>right now.</em></h2>
      <p class="section-lead">
        Choose the fastest way to get the answer or support you need.
      </p>

      <div class="quick-actions-inner">
        <a href="https://academy.nexgencoaches.com/live-session" target="_blank" rel="noopener noreferrer" class="qa-card">
          <div class="qa-icon"><i class="fa-solid fa-video"></i></div>
          <div class="qa-divider"></div>
          <div class="qa-text">
            <strong>Join a Free Webinar</strong>
            <span>Ask questions live with our team</span>
          </div>
          <i class="fa-solid fa-arrow-right qa-arrow"></i>
        </a>

        <a href="tel:+12482708373" target="_blank" rel="noopener noreferrer" class="qa-card">
          <div class="qa-icon phone-icon"><i class="fa-solid fa-phone"></i></div>
          <div class="qa-divider"></div>
          <div class="qa-text">
            <strong>Call Us</strong>
            <span>+1 (248) 270-8373</span>
          </div>
          <i class="fa-solid fa-arrow-right qa-arrow"></i>
        </a>

        <a href="https://nexgencoaches.com/contact-us/" target="_blank" rel="noopener noreferrer" class="qa-card">
          <div class="qa-icon email-icon"><i class="fa-solid fa-envelope"></i></div>
          <div class="qa-divider"></div>
          <div class="qa-text">
            <strong>Send a Message</strong>
            <span>Response within 1 business day</span>
          </div>
          <i class="fa-solid fa-arrow-right qa-arrow"></i>
        </a>

        <a href="https://academy.nexgencoaches.com/community" target="_blank" rel="noopener noreferrer" class="qa-card">
          <div class="qa-icon community-icon"><i class="fa-solid fa-users"></i></div>
          <div class="qa-divider"></div>
          <div class="qa-text">
            <strong>Community</strong>
            <span>Ask fellow students</span>
          </div>
          <i class="fa-solid fa-arrow-right qa-arrow"></i>
        </a>
      </div>
    </div>
  </section>

  <!-- ═══════════════════════════════════════════════
       SEARCH RESULTS
  ═══════════════════════════════════════════════ -->
  <section class="help-content" *ngIf="searchTerm">
    <div class="help-content-inner">
      <div class="search-header">
        <h2 *ngIf="searchResults.length > 0">
          <strong>{{ searchResults.length }}</strong> result{{ searchResults.length !== 1 ? 's' : '' }}
          for "<em>{{ searchTerm }}</em>"
        </h2>
        <h2 *ngIf="searchResults.length === 0">
          No results for "<em>{{ searchTerm }}</em>"
        </h2>
        <button type="button" class="btn-clear-search" (click)="clearSearch()">
          <i class="fa-solid fa-rotate-left"></i> Browse All Topics
        </button>
      </div>

      <div class="search-results-list" *ngIf="searchResults.length > 0">
        <div
          class="search-result-item"
          *ngFor="let r of searchResults"
          (click)="openArticle(r)">
          <div class="sr-icon"><i [class]="r.categoryIcon"></i></div>
          <div class="sr-divider"></div>
          <div class="sr-body">
            <div class="sr-category">{{ r.categoryLabel }}</div>
            <h3 class="sr-title">{{ r.title }}</h3>
            <p class="sr-excerpt">{{ r.excerpt }}</p>
          </div>
          <i class="fa-solid fa-chevron-right sr-arrow"></i>
        </div>
      </div>

      <div class="no-results-block" *ngIf="searchResults.length === 0">
        <div class="nr-icon"><i class="fa-solid fa-inbox"></i></div>
        <h3>Nothing found</h3>
        <p>Try different keywords, or browse our help topics below.</p>
        <button type="button" class="btn-browse" (click)="clearSearch()">Browse All Help Topics</button>
      </div>
    </div>
  </section>

  <!-- ═══════════════════════════════════════════════
       HELP CATEGORIES — white-section
       matches FAQ white-section faq-main-section layout
  ═══════════════════════════════════════════════ -->
  <section class="help-categories white-section" *ngIf="!searchTerm">
    <div class="help-categories-inner">

      <div class="hc-section" *ngFor="let cat of helpCategories" [attr.aria-labelledby]="'help-cat-title-' + cat.id">

        <!-- Group intro — same as faq-group-intro -->
        <div class="hc-group-intro">
          <p class="gold-eyebrow">{{ cat.title }}</p>
          <h2 [id]="'help-cat-title-' + cat.id">
            {{ cat.title.split(' ')[0] }}
            <em>{{ cat.title.substring(cat.title.indexOf(' ') + 1) }}</em>
          </h2>
          <p class="section-lead hc-group-lead">{{ cat.subtitle }}</p>
        </div>

        <!-- Article list — same as faq-list -->
        <div class="hc-articles">
          <div
            class="hc-article"
            *ngFor="let article of cat.articles"
            [class.expanded]="article.expanded"
            (click)="toggleArticle(article)">

            <div class="hca-top">
              <div class="hca-left">
                <span class="hca-tag" [class]="'tag-' + cat.tagColor">{{ cat.tag }}</span>
                <h3 class="hca-title">{{ article.title }}</h3>
              </div>
              <div class="hca-chevron">
                <i class="fa-solid fa-chevron-down"></i>
              </div>
            </div>

            <div class="hca-body" [style.maxHeight]="article.expanded ? '800px' : '0px'">
              <div class="hca-body-inner" [innerHTML]="article.content"></div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </section>

  <!-- ═══════════════════════════════════════════════
       ARTICLE MODAL
  ═══════════════════════════════════════════════ -->
  <div class="article-modal-backdrop" *ngIf="openedArticle" (click)="closeArticle()">
    <div class="article-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="help-modal-title">
      <div class="modal-top-bar">
        <span class="modal-category">{{ openedArticle.categoryLabel }}</span>
        <button type="button" class="modal-close" (click)="closeArticle()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <h2 id="help-modal-title" class="modal-title">{{ openedArticle.title }}</h2>
      <div class="modal-content" [innerHTML]="openedArticle.fullContent"></div>
      <div class="modal-footer">
        <p>Was this helpful?</p>
        <div class="helpful-btns">
          <button type="button" class="btn-helpful" (click)="markHelpful(true)">
            <i class="fa-solid fa-thumbs-up"></i> Yes
          </button>
          <button type="button" class="btn-helpful" (click)="markHelpful(false)">
            <i class="fa-solid fa-thumbs-down"></i> No
          </button>
        </div>
        <p class="still-need" *ngIf="helpfulSubmitted">
          {{ helpfulResponse }}
        </p>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════════════
       MOST ASKED — cream-section with feature-table
       identical structure to FAQ "Most Asked" section
  ═══════════════════════════════════════════════ -->
  <section class="cream-section" *ngIf="!searchTerm">
    <div class="cx">
      <p class="gold-eyebrow">MOST ASKED</p>
      <h2>Start with these <em>common questions.</em></h2>
      <p class="section-lead">
        These are the questions students ask most when they need help quickly.
      </p>

      <div class="faq-feature-table">
        <div class="ft-row">
          <div class="ft-num-col"><span class="ft-num">01</span></div>
          <div class="ft-divider-col"><div class="ft-line"></div></div>
          <div class="ft-main-col">
            <strong>How do I log in to the NEXGEN platform?</strong>
            <p>Go to academy.nexgencoaches.com/login and use the email and password connected to your enrollment. Check spam if credentials did not arrive.</p>
          </div>
          <div class="ft-result-col">
            <div class="result-quote"><em>Your account is created automatically when you enroll.</em></div>
          </div>
        </div>

        <div class="ft-row">
          <div class="ft-num-col"><span class="ft-num">02</span></div>
          <div class="ft-divider-col"><div class="ft-line"></div></div>
          <div class="ft-main-col">
            <strong>What is the Barter Coaching Platform?</strong>
            <p>The Barter Coaching Platform helps Gold and Platinum students practice coaching with peers and log coaching hours with real people.</p>
          </div>
          <div class="ft-result-col">
            <div class="result-quote"><em>It solves one of the biggest problems new coaches face: getting hours.</em></div>
          </div>
        </div>

        <div class="ft-row">
          <div class="ft-num-col"><span class="ft-num">03</span></div>
          <div class="ft-divider-col"><div class="ft-line"></div></div>
          <div class="ft-main-col">
            <strong>How do I upgrade from Silver to Gold or Gold to Platinum?</strong>
            <p>You only pay the price difference between programs. Your progress and logged hours carry over completely. Contact support to start the upgrade.</p>
          </div>
          <div class="ft-result-col">
            <div class="result-quote"><em>You do not lose progress. You keep building forward.</em></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ═══════════════════════════════════════════════
       CTA — matches FAQ faq-cta section exactly
  ═══════════════════════════════════════════════ -->
  <section class="help-contact-cta" *ngIf="!searchTerm">
    <div class="help-contact-inner">
      <div class="faq-cta-icon"><i class="fa-solid fa-headset"></i></div>

      <div class="hcc-left">
        <p class="gold-eyebrow">STILL NEED HELP?</p>
        <h2>Still have <em>questions?</em></h2>
        <p>Our support team responds within one business day. No bots. Just people who know the platform.</p>
      </div>

      <div class="hcc-right">
        <a
          href="https://nexgencoaches.com/contact-us/"
          target="_blank"
          rel="noopener noreferrer"
          class="hcc-btn-primary">
          <i class="fa-solid fa-paper-plane"></i>
          Send Us a Message
        </a>
        <a
          href="tel:+12482708373"
          target="_blank"
          rel="noopener noreferrer"
          class="hcc-btn-phone">
          <i class="fa-solid fa-phone"></i>
          +1 (248) 270-8373
        </a>
      </div>
    </div>
  </section>

</div>
<app-bottomside></app-bottomside>